var leica = window.leica || {};
leica.pi = leica.pi || {};
leica.pi.util = leica.pi.util || {};

/**
 * Utility function to save JSON to a file
 * 
 * Example:
 * Call from the debugger like
 *       console.save(object);
 */
(function(console) {
    console.save = function(data, filename)
    {
        if (!data)
        {
            console.error('Console.save: No data');
            return;
        }
        if (!filename)
        {
            filename = 'console.json';
        }

        if (typeof data === "object") {
            data = JSON.stringify(data, undefined, 4);
        }

        var blob = new Blob([data], {type: 'text/json'});
        var e = document.createEvent('MouseEvents');
        var a = document.createElement('a');
        a.download = filename;
        a.href = window.URL.createObjectURL(blob);
        a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
        e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        a.dispatchEvent(e);
    };
})(console);

/**
 * Extend jQuery with ajax method dedicated to POSTing JSON
 */
jQuery.postJSON = function(url, data) {
    return jQuery.ajax({
        url: url,
        type: "POST",
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        data: data
    });
};


// Test if jquery object 'exists'
jQuery.fn.exists = function() {
    return this.length > 0;
};

// This code is used to create a busy cursor while a redirect was happening. -cb
// Work around for webkit bug: Change to cursor does not take effect until mouse moved. 
// See: https://code.google.com/p/chromium/issues/detail?id=26723#c87
//      http://stackoverflow.com/questions/1718415/getting-the-browser-cursor-from-wait-to-auto-without-the-user-moving-the-mou
// Note: Workaround below does not appear to work
leica.pi.util.setCursor = function(cursor)
{
    if (document.body.style.cursor != cursor)
    {
        var wkch = document.createElement("div");
        wkch.style.overflow = "hidden";
        wkch.style.position = "absolute";
        wkch.style.left = "0px";
        wkch.style.top = "0px";
        wkch.style.width = "100%";
        wkch.style.height = "100%";
        var wkch2 = document.createElement("div");
        wkch2.style.width = "200%";
        wkch2.style.height = "200%";
        wkch.appendChild(wkch2);
        document.body.appendChild(wkch);
        document.body.style.cursor = cursor;
        wkch.scrollLeft = 1;
        wkch.scrollLeft = 0;
        document.body.removeChild(wkch);
    }
};

/**
 * Show a message to the user
 * Use pnotify (a toast-like transient pop message utility) or standard alert
 * In the case of pnotify, the single parameter (message) is the text to display, or a JavaScript object of options
 * Example notice with custom options: $.pnotify({title: "Title", text: "Message text."});
 * @param message 
 */
leica.pi.util.showMessage = function(message)
{
    try
    {
        if ($.pnotify)
        {
            $.pnotify(message);
        }
        else
        {
            if (typeof message === 'object')
            {
                var extractedMessage = ('title' in message) ? message.title + ': ' : '' + ('text' in message) ? text : JSON.stringify(message);
                alert(extractedMessage);
            }
            else
            {
                alert(message);
            }
        }
    }
    catch (err)
    {
        //swallow errors during alert
        // something went really wrong
    }
};
